import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import jaLocale from '@fullcalendar/core/locales/ja';

export function calender() {
  const calendarEl = document.querySelector('.js-calendar');
  if(calendarEl){
    const lang = calendarEl.dataset.lang;
    let initialLocale = '';
    if(lang == 'ja') {
      initialLocale = jaLocale;
    } else {
      initialLocale = 'en';
    }

    const calendar = new Calendar(calendarEl, {
      plugins: [ dayGridPlugin ],
      locale: initialLocale,
      events: api_calendar,
      height: 'auto'
    });

    calendar.render();
  }
}